export default __webpack_public_path__ + "static/media/Focus.be02c6c1.svg";